import type { FaireProductEntity } from "../../entity_types/product";

export const p_v34vuaa3dz: FaireProductEntity = {
  token: "p_v34vuaa3dz",
  type: "product",
  name: "Giant Natural Arkansas Quartz Crystal",
  brandToken: "b_wmrj23yq37",
  brandName: "Wildheart Crystals",
  imageUrl:
    "https://cdn.faire.com/fastly/687c4afe713ac5225ede41bdde0fa4cf2c4e701ea3f70c0fee8963982a54bfdf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d3b4a7e74d3a5a65dff78f46681aec9c14ee86df6a16e69fc63584d34ed2fdf0.jpeg",
    "https://cdn.faire.com/fastly/086565849d89ec1588c9fb6c94b1dc5771fd6688e065678eb884646172238aef.jpeg",
    "https://cdn.faire.com/fastly/18c8f353e9e1620457dec6d83f17db7681ebd50f07e0e57d242b844671365b52.jpeg",
    "https://cdn.faire.com/fastly/472e83c97700260a176bbc11651bea4e8d1dd944354da134459f5b26c270f843.jpeg",
    "https://cdn.faire.com/fastly/947de00b03ed76ee15ac91a3ae7827103fc60271335e0fd006076c9bf42f40db.jpeg",
    "https://cdn.faire.com/fastly/5b0d9f6976f9cf5bcdb9d39567628b654a968f1c2df3e0bb8816ff54cef69866.jpeg",
    "https://cdn.faire.com/fastly/9e449a90ef6e20419a09fa8a51fca741e6c452980100ce3d9ad213baeb0356d8.jpeg",
    "https://cdn.faire.com/fastly/8864b9bf5b5cc6363ac720dab85ff040fb2896759254580893712b6a372bf9e2.jpeg",
    "https://cdn.faire.com/fastly/0e068d6e034f75218050f04dfe6c39cae6c6383969d82ad5d0678267382ee335.jpeg",
  ],
  priceDollars: 119.17,
  description:
    "Explore the realm of spirituality with our Giant Natural Arkansas Quartz Crystal from Wildheart Crystals. This stunning piece, with its unique and captivating formation, is a testament to the natural beauty of gemstones. The crystal's size is substantial, as seen in the provided pictures. It's not just about aesthetics; the metaphysical properties of this Arkansas quartz crystal can enhance your spiritual journey. Ideal for those seeking a connection with nature's energy, this crystal exemplifies our commitment to quality and natural, untreated gems.",
  tags: [],
  msrpDollars: 238.34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:27.241Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
